import { PeekCheckbox, PeekSelect, PeekSelectOption, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import React from "react";
const MultipleSelectorWithCount = ({ label, items, selectedItems, setItems, inactiveItemsIndexes, renderValue, isCombined, }) => {
    const theme = useTheme();
    return (React.createElement(PeekSelect, { value: selectedItems, onChange: (event) => setItems(event.target.value), showBorder: true, centerText: true, multiple: true, renderValue: renderValue
            ? renderValue
            : (value) => (React.createElement(PeekStack, { direction: "row", width: "fit-content", spacing: 2 },
                React.createElement(PeekTypography, null, label),
                React.createElement(PeekTypography, { sx: {
                        backgroundColor: theme.palette.secondary.main,
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        color: theme.palette.common.white,
                        letterSpacing: "1px",
                        lineHeight: "16px",
                    } }, value.length))), inputProps: { "aria-label": `${label} Selector` }, MenuProps: {
            disablePortal: true,
            sx: {
                "& .MuiPaper-root": {
                    borderRadius: "8px",
                    minWidth: "160px !important",
                },
                "& .MuiMenuItem-root": {
                    justifyContent: "space-between !important",
                },
            },
        }, sx: {
            minHeight: "fit-content",
            height: "42px",
            fontWeight: "fontWeightMedium",
            borderTopRightRadius: isCombined ? 0 : "8px",
            borderBottomRightRadius: isCombined === "left" ? 0 : "8px",
            borderTopLeftRadius: isCombined === "right" ? 0 : "8px",
            borderRight: isCombined === "left" ? "none" : `1px solid ${theme.palette.grey[200]}`,
            borderLeft: isCombined === "right" ? "none" : `1px solid ${theme.palette.grey[200]}`,
            ".MuiMenuItem-root": {
                padding: 0,
            },
            ".Mui-selected": { backgroundColor: `${theme.palette.common.white} !important` },
        } }, items.map((item, index) => {
        return (React.createElement(PeekSelectOption, { key: item, value: item, disabled: inactiveItemsIndexes === null || inactiveItemsIndexes === void 0 ? void 0 : inactiveItemsIndexes.includes(index) },
            React.createElement(PeekStack, { direction: "row", width: "100%", alignItems: "center" },
                React.createElement(PeekCheckbox, { checked: selectedItems.includes(item), sx: {
                        svg: {
                            color: selectedItems.includes(item) ? `${theme.palette.secondary.main} !important` : "inherit",
                        },
                    } }),
                React.createElement(PeekTypography, null, item))));
    })));
};
export default MultipleSelectorWithCount;
